module.exports = __webpack_public_path__ + "img/sample-wide.eec5c113.jpg";